import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FicScreenContentBase } from '../../../fic-screen/fic-screen-content-base';
import { ObjectTypes } from '@fi-shared/types';

// todo: remove
@Component({
    selector: 'fi-comment-add-screen',
    template: `
        <fic-screen>
            <fic-screen-header>
                <fic-screen-header-prefix>
                    <fic-screen-btn-close></fic-screen-btn-close>
                </fic-screen-header-prefix>
                {{ 'common.reply' | fiAppText }}
            </fic-screen-header>
            <fic-screen-content>
                <div class="fi-container-vertical">
                    <mat-card class="fi-content-card">
                        <fi-comment-add
                            [objectId]="data.objectId"
                            [objectType]="data.objectType"
                            [instanceId]="data.instanceId"
                            [parentCommentId]="data.parentCommentId"
                            [isReply]="!!data.parentCommentId"
                            [saveButtonText]="'common.send' | fiAppText"
                            (commentSaved)="onCommentSaved()"
                            (commentEditCancelled)="onCommendEditCancelled()"
                        />
                    </mat-card>
                </div>
            </fic-screen-content>
        </fic-screen>
    `,
    styleUrls: ['./fi-comment-add-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-comment-add-screen' },
    standalone: false,
})
export class FiCommentAddScreenComponent extends FicScreenContentBase<{
    objectId: number;
    objectType: ObjectTypes;
    instanceId: string;
    parentCommentId?: number;
}> {
    protected onCommentSaved(): void {
        this.closeScreen();
    }

    protected onCommendEditCancelled(): void {
        this.closeScreen();
    }
}
